import React, { useEffect, useState } from 'react';
import './Mint.css';
import SwitchLight from '../../assets/images/light/switch-light.png';
import SwitchDark from '../../assets/images/dark/switch-dark.png';
import facehLight from '../../assets/images/light/light-menu.png';
import facehDark from '../../assets/images/dark/dark-menu.png';
import nav from '../../assets/images/nav.png';
import minus from '../../assets/images/minus.png';
import plus from '../../assets/images/plus.png';
import mintButton from '../../assets/images/mint-btn.png';
import walletConnect from '../../assets/images/mint/connect-wallet.png';
import closeButton from '../../assets/images/menu-close.png';
import Navbar from '../navbar/Navbar';

import desktopLight from '../../assets/images/mint/mint-l.png';
import desktopDark from '../../assets/images/mint/mint-d.png';
import mobileLight from '../../assets/images/mobile/mint/mint-l.png';
import mobiledark from '../../assets/images/mobile/mint/mint-d.png';

import { initOnboard } from '../../utils/onboard';
import { useConnectWallet, useSetChain, useWallets } from '@web3-onboard/react';

const Mint = (props) => {
  const [expand, setExpand] = useState(false);
  const [onboard, setOnboard] = useState(null);
  const connectedWallets = useWallets();
  const [{ wallet, connecting }, connect, disconnect] = useConnectWallet();

  const [image, setImage] = useState(
    window.innerWidth > 425
      ? props.mod
        ? desktopDark
        : desktopLight
      : props.mod
      ? mobiledark
      : mobileLight
  );

  const setAnimation = (ev) => {
    let el = document.getElementById('foo');
    el.style.height = el.getBoundingClientRect().height + 5 + 'px';
  };

  const checkDrag = (e) => {
    let ds = document.getElementById('foo');

    window.innerWidth > 425
      ? props.mod
        ? (ds.style.top = '-30px')
        : (ds.style.top = '0px')
      : props.mod
      ? (ds.style.top = '-30px')
      : (ds.style.top = '0px');
    if (e >= 380) {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopDark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobiledark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobileLight);
        props.changeTheme(!props.mod);
      }
    } else {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopLight);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopDark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobiledark);
        props.changeTheme(!props.mod);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobileLight);
        props.changeTheme(!props.mod);
      }
    }
  };

  const navAction = () => {
    setExpand(!expand);
  };

  useEffect(() => {
    function chechSize(e) {
      if (window.innerWidth > 425 && props.mod) {
        setImage(desktopDark);
      } else if (window.innerWidth > 425 && !props.mod) {
        setImage(desktopLight);
      } else if (window.innerWidth <= 425 && props.mod) {
        setImage(mobiledark);
      } else if (window.innerWidth <= 425 && !props.mod) {
        setImage(mobileLight);
      }
    }

    window.addEventListener('resize', chechSize());
  });

  //wallet connect
  useEffect(() => {
    setOnboard(initOnboard);
  }, []);

  //store in localstorage
  useEffect(() => {
    if (!connectedWallets.length) return;

    const connectedWalletsLabelArray = connectedWallets.map(
      ({ label }) => label
    );
    window.localStorage.setItem(
      'connectedWallets',
      JSON.stringify(connectedWalletsLabelArray)
    );
  }, [connectedWallets]);

  //get from localstorage
  useEffect(() => {
    if (!onboard) return;

    const previouslyConnectedWallets = JSON.parse(
      window.localStorage.getItem('connectedWallets')
    );

    if (previouslyConnectedWallets?.length) {
      async function setWalletFromLocalStorage() {
        await connect({
          autoSelect: {
            label: previouslyConnectedWallets[0],
            disableModals: true,
          },
        });
      }

      setWalletFromLocalStorage();
    }
  }, [onboard, connect]);

  return (
    <div className=" w-full h-screen flex flex-col relative overflow-y-hidden overflow-x-hidden">
      <div className=" w-full h-full absolute">
        <img
          src={image}
          className="  z-40  w-full h-full "
          loading="lazy"
        />
      </div>

      <div className=" flex flex-col w-full h-full relative  ">
        <div
          className={`w-full h-auto flex flex-row  justify-between relative`}
        >
          <div
            id="foo"
            className={`flex flex-col w-[178px] z-50  ss ${
              props.mod
                ? ' xxs:-top-[30px] sm:top-[0px]'
                : 'xxs:-top-[30px] sm:top-[0px]'
            }   xxs:h-[190px]  sm:h-auto xs:-left-10 sm:left-0  relative cursor-move`}
            onClick={(e) => {
              checkDrag(e.clientY);
            }}
          >
            <img
              src={props.mod ? SwitchDark : SwitchLight}
              alt="switch"
              className="w-auto h-full"
            />
          </div>
          <div className="flex flex-col w-fit h-fit  cursor-pointer     relative">
            <img
              src={props.mod ? facehLight : facehDark}
              className={`relative ${
                expand ? 'event-rm' : 'event-add'
              } navhover xxs:w-[60%] xxs:h-auto sm:w-[65%] xxs:left-12 xs:-top-2  sm:top-7 md:left-9 lg:left-0  sm:h-auto z-[999]  `}
              alt="face"
              onClick={navAction}
            />
          </div>
        </div>
        <div
          className={`w-full   flex-col h-full  z-[999]  top-0 right-0   absolute   backdrop-blur-sm     ${
            expand ? 'flex' : 'hidden'
          } justify-center items-center`}
        >
          <div className=" flex-row flex  w-full h-fit justify-center items-center  relative z-0 bg-menu">
            <div className=" flex-row flex  w-full h-fit justify-center items-center  relative z-0 bg-menu mb-20">
              <div className=" flex-row flex  xxs:w-[450px] sm:w-[530px] h-fit justify-center items-center  relative z-0">
                <img
                  src={nav}
                  alt="nav"
                  className="  w-[1050px]  xxs:h-[400px] sm:h-[500px]     absolute    order-2 "
                />
                <img
                  src={closeButton}
                  alt="closeBtn"
                  className="w-[130px] z-40 xxs:-top-10  xs:-top-10  sm:top-1 xxs:right-10 sm:right-16 xxs:h-[180px] sm:h-fit    absolute order-1      cursor-pointer close-btn"
                  onClick={navAction}
                />
                <div className=" xxs:mt-12 sm:mt-16  relative sm:-left-5">
                  <Navbar />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="  w-full  flex  flex-col h-full  xxs:top-[90px]   md:top-[22%] right-0   absolute justify-center items-center">
          <div className=" flex w-auto  flex-row relative     items-center function-container  ">
            <img
              src={minus}
              alt="minus"
              className={`close-btn  xxs:w-[100px]  xxs:h-[100px] cursor-pointer  relative text-center 2xl:w-[150px]  3xl:w-[200px] 3xl:pr-20`}
            />
            <input
              type="text"
              className={`  text-black border-[2px] border-black xxs:w-[80px] xxs:h-[50px] text-5xl sm:w-[40px] lg:w-[50px] xl:w-[70px] sm:border-none  font-child font-extrabold  outline-none xxs:mx-0 md:mx-10  px-2 bg-transparent  relative  `}
            />
            <img
              src={plus}
              alt="plues"
              className={`close-btn xxs:w-[100px] xxs:h-[100px] cursor-pointer  relative text-center 2xl:w-[150px] 3xl:w-[200px] 3xl:pl-2 `}
            />
          </div>
          <div className="flex h-auto  relative  z-10">
            <button className=" relative w-fit h-fit  xxs:w-[200px] xxs:left-12  2xl:w-[400px] 3xl:w-[350px]">
              <img src={mintButton} alt="mintBtn" className=" mint-btn" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mint;
